import { jsx as _jsx } from "react/jsx-runtime";
export function FullScreenQuad({ meshRef, material, renderOrder, }) {
    return (_jsx("mesh", { ref: meshRef, material: material, renderOrder: renderOrder, 
        // The quad ignores every matrix, so its bounds say nothing about where it lands, and culling
        // it against the panned camera would drop it.
        frustumCulled: false, children: _jsx("planeGeometry", { args: [1, 1] }) }));
}
//# sourceMappingURL=fullScreenQuad.js.map